import api from "./axiosClient.js";

export const getSeatingCategories = async (restaurantId) => {
    const res = await api.get(`/seating-categories/${restaurantId}`);
    return res.data;
};

export const getSeatingAreas = async (restaurantId, category) => {
    const res = await api.get(`/seating-areas/${restaurantId}/${encodeURIComponent(category)}`);
    return res.data;
};

// ✅ Deprecated - kept for reference
export const getTables = async (area) => {
    const res = await api.get(`/tables/${encodeURIComponent(area)}`);
    return res.data;
};
